// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PageRegister__tooltipAfterInput{position:absolute;right:-1rem;top:calc(.75em - .1875rem + 1px)}@media(min-width:1024px){.PageRegister__tooltipAfterInput{right:-2.125rem}}@media(min-width:768px)and (max-width:1023.98px){.PageRegister__inputHouseNumber{padding-left:.25rem;padding-right:.25rem}}@media(min-width:1024px){.PageRegister__inputHouseNumber+.invalid-feedback{white-space:nowrap}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
